import { Quote } from 'components/Quote'
import { ReactNode } from 'react'

export const content_politik: {
  title: string
  author: string
  autorBio: string
  content: ReactNode
  link: number
}[] = [
  {
    title: 'Soll die Schweiz neutral bleiben?',
    author: 'Philipp Loser',
    autorBio: '62565119/philipp-loser',
    content: (
      <>
        <p>
          Ist diese Frage richtig gestellt? Müsste es nicht heissen: Kann die
          Schweiz neutral bleiben? Als im Februar die Russen in der Ukraine
          einmarschierten, war das ein Akt von so eindeutiger Aggressivität und
          Brutalität, dass man als Westeuropäer auf einer emotionalen Ebene
          nicht neutral bleiben konnte.
        </p>
        <p>
          Das galt auch (und erstaunlicherweise) für die offizielle Schweiz, die
          innerhalb von wenigen Tagen und nach einigem innenpolitischen Druck
          die Sanktionen der EU gegen Russland übernahm.
        </p>
        <p>War das noch neutral? Ist das noch neutral?</p>
        <Quote>
          Das entscheiden wir nicht selber. Das entscheidet die Welt.
        </Quote>
        <p>
          Aussenminister Ignazio Cassis wollte daraufhin im Bundesrat die
          Neutralität der Schweiz neu definieren – und lief auf. Die
          Gesamtregierung hielt nichts von der Cassis’schen Neukonzeption und
          blieb lieber bei der aktiven Neutralität, so wie sie seit dem Vertrag
          von Paris von 1815 mehr oder weniger in der Schweiz gelebt und stets
          «flexibel den Umständen» angepasst wird, wie es in einer Broschüre des
          Aussendepartements heisst.
        </p>
        <p>
          Druck für eine Anpassung an die neuen Umstände kommt jetzt von dort,
          wo Druck in der Schweiz meistens auch etwas bewirkt – von aussen.
        </p>
        <p>Soll die Schweiz neutral bleiben?</p>
        <p>Das entscheiden wir nicht selber. Das entscheidet die Welt.</p>
      </>
    ),
    link: 598128436666,
  },
  {
    title: 'Können Mütter gute Bundesrätinnen sein?',
    author: 'Michèle Binswanger',
    autorBio: '91350405/michele-binswanger',
    content: (
      <>
        <p>
          Selbstverständlich können Mütter gute Bundesrätinnen sein. Es ist ja
          nicht so, dass Mutterschaft einer geistigen Behinderung entspricht, im
          Gegenteil. Wenn Frauen gute Bundesrätinnen sein können, dann gilt das
          für Mütter umso mehr. Eine Persönlichkeit reift in der Mutterschaft
          eher, sicher aber wird sie arg getestet, was für den Bundesratsjob ein
          Vorteil ist, Stichwort Belastbarkeit.
        </p>
        <p>
          Und warum gab es dann noch nie eine junge Mutter im Bundesrat? Damit
          kommen wir zur umgekehrten Frage: Können Bundesrätinnen gute Mütter
          sein? Wobei man hierzu erst mal definieren müsste, was eine gute
          Mutter eigentlich ausmacht. Und warum sich diese Frage bei den Vätern
          offenbar nicht zu stellen scheint.
        </p>
        <Quote>
          Früher oder später wird sicher eine Mutter mit kleinen Kindern in der
          Landesregierung vertreten sein.
        </Quote>
        <p>
          Vielleicht liegt es am hierzulande noch stark verbreiteten
          Mutterideal, das von Frauen verlangt, immer bei ihren Kindern zu sein
          und sich aufopfernd zu kümmern. Hingegen muss ein Mitglied des
          Bundesrats die Anforderungen dieser Stellung an erste Stelle setzen.
          Ganz egal, ob die Kinder krank sind oder im Gefängnis landen oder
          welche Probleme sich auch immer gerade stellen. Ein Bundesrat, eine
          Bundesrätin muss bereit sein, das Wohl des Landes zur ersten Priorität
          zu machen, und zwar unter allen Umständen.
        </p>
        <p>
          Dazu scheinen Väter nach wie vor eher bereit zu sein als Mütter. Aber
          früher oder später wird sicher auch eine Mutter mit kleinen Kindern in
          der Landesregierung vertreten sein.
        </p>
      </>
    ),
    link: 801569484452,
  },
  {
    title: 'Müssen Geflüchtete dankbar sein?',
    author: 'Christian Zürcher',
    autorBio: '41851756/christian-zurcher',
    content: (
      <>
        <p>
          Natürlich sollen sie das. Doch es ist falsch, als Gastgeber von ihnen
          zu erwarten, dass sie aus lauter Dankbarkeit nur noch schweigen und
          alles mit sich gefallen lassen.
        </p>
        <p>
          Offenbar denkt ein Teil der Bevölkerung anders. Zu diesem Eindruck kam
          man, als im Herbst in Luzern eine Dankbarkeitsdebatte entstand. Dort
          fragten ukrainische Flüchtlinge, welche Rechte sie hätten und ob es in
          Ordnung sei, dass sie von den Angestellten in der Unterkunft
          gedemütigt würden.
        </p>
        <Quote>
          Zu einer gelungenen Integration gehört die Möglichkeit,
          selbstbestimmt zu leben.
        </Quote>
        <p>
          Als der von ihnen verfasste Brief an die Öffentlichkeit kam, war die
          Reaktion der Bevölkerung harsch. Die Flüchtlinge hörten auf der
          Strasse und lasen im Internet, wie frech und undankbar sie seien und
          wie man ihnen die Hilfe kappen sollte. Oder in aller Kürze: «ALLE
          RAUS. FERTIG.»
        </p>
        <p>
          Zu einer gelungenen Integration gehört die Möglichkeit, selbstbestimmt
          zu leben. Und dazu gehört auch, eigene Rechte einfordern zu dürfen und
          sich über Missstände zu beschweren.
        </p>
        <p>
          Wenn nun 60’000 Menschen aus der Ukraine in die Schweiz flüchten, ist
          es einerseits normal, dass nicht alles von Anfang an klappt.
          Andererseits ist es gar nicht souverän, in einer solchen Situation das
          Problem bei den Geflüchteten zu suchen. Souveräner wäre, die Probleme
          zu lösen und den Menschen im Ausnahmezustand das Leben nicht noch zu
          erschweren.
        </p>
      </>
    ),
    link: 947778718809,
  },
  {
    title: 'Darf man für den Klimaschutz das Gesetz brechen?',
    author: 'Martin Läubli',
    autorBio: '75634542/martin-laubli',
    content: (
      <>
        <p>
          Nötigung, Hausfriedensbruch, Sachbeschädigung – die Liste der Anklagen
          gegen Klimaaktivistinnen und -aktivisten in Europa wird immer länger.
          Sie heissen «Renovate Switzerland» oder «Letzte Generation» und
          gehören sozusagen zur Post-Greta-Generation, die sich nicht mehr mit
          harmlosen Sitzstreiks und Grossdemonstrationen begnügen will. Sie
          glauben, diese friedfertigen Mittel seien ausgeschöpft und Regierungen
          nur noch durch aggressive Aktionen zum Handeln zu bewegen. Sie sind
          überzeugt, das moralische Recht auf ihrer Seite zu haben, um Strassen
          zu blockieren, wertvolle Gemälde zu beschädigen oder protestierend in
          Banken einzudringen. Die Menschheit befinde sich in einem
          Klimanotstand und es passiere zu wenig, rechtfertigen Vertreterinnen
          und Vertreter von «Renovate Switzerland» oder «Letzte Generation» ihre
          Taten.
        </p>
        <p>
          Vom moralischen Standpunkt aus kann man das so sehen. An der
          Klimakonferenz in Ägypten gab es zwar starke Appelle zum Handeln, aber
          die politische Ausbeute blieb dürftig.
        </p>
        <Quote>
          Fragwürdig ist, ob aggressive Klimaaktionen die gewünschte Wirkung in
          der Gesellschaft zeigen.
        </Quote>
        <p>
          Dennoch: Vor dem Gesetz bleibt es eine Straftat. Der im juristischen
          Jargon bezeichnete «rechtfertigende Notstand» reicht nicht aus, um
          illegale Taten – selbst für den Umweltschutz – straffrei zu lassen. So
          jedenfalls hat das Bundesgericht eine Klimaaktion in einer
          Eingangshalle der Credit Suisse in Lausanne beurteilt. Es stünden
          legale Mittel zur Verfügung, um auf Missstände aufmerksam zu machen.
          Der Aufmarsch der Klimajugend etwa hat in der Schweiz vor drei Jahren
          auf legale Weise den Ausgang der Parlamentswahlen zugunsten der grünen
          Politik beeinflusst.
        </p>
        <p>
          Deshalb ist es richtig, in einem Rechtsstaat gesetzliche Übertretungen
          – selbst für den Klimaschutz – zu ahnden. Letztlich sollte ohnehin
          nicht nur die Frage nach dem Gesetzesbruch gestellt werden. Fragwürdig
          ist auch, ob aggressive Klimaaktionen die gewünschte Wirkung in der
          Gesellschaft zeigen. Eine Umfrage hat zumindest in Deutschland
          gezeigt, dass eine Mehrheit der Bevölkerung sie als kontraproduktiv
          empfindet.
        </p>
      </>
    ),
    link: 306492818578,
  },
]
